import React from "react";
import { Link } from "react-router-dom";
const IconHeadMob = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: `grid-2-iconHeading ${props.parentClassName}` },
                React.createElement("span", { className: "icon" }, props.icon),
                React.createElement("span", { className: "icon-title" }, props.linkContent && (React.createElement(Link, { to: props.linkContent, className: "icon-title" }, props.tilte)))))));
};
export default IconHeadMob;
